import type { UserPermissions } from "../../types";

export function isLcsw(permissions: Nullable<UserPermissions>): boolean {
  return permissions?.lcsw?.is_lcsw === true;
}
